import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getTaskList() {
  return axios.post(APP_SETTINGS.API_PATH.TASK.getTaskList);
}

export function removeTask(taskId, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.TASK.removeTask,
    { requestId: taskId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function removeBoard(boardId, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.TASK.removeBoard,
    { requestId: boardId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function editTask(taskData, token) {
  var resp = axios.post(APP_SETTINGS.API_PATH.TASK.editTask, taskData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp;
}

export function fetchWorkingHours(request, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.getWorkingHours, request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function fetchProjectBoards(request, token) {
  var resp = axios.post(
    APP_SETTINGS.API_PATH.TASK.getProjectTaskList,
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return resp;
}

export function updateTaskBoardsOrderApi(userId, data, token) {
  return axios.put(
    `${APP_SETTINGS.API_PATH.TASK_BOARD.updateTaskBoardsOrder}/${userId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function fetchNextBoardTask(request, token) {
  // console.log("request ::::", request)
  var resp = axios.post(
    APP_SETTINGS.API_PATH.TASK.getNextProjectTaskList,
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  // console.log("resp ::::", resp)
  return resp;
}

export function getUsersDataForInviteInProject(id, token) {
  let url = `${APP_SETTINGS.API_PATH.TASK.getUsersDataForInviteInProject}?organizationId=${id}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function updateBulkTaskData(taskData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.UpdateBulkTaskData, taskData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createProjectTask(task, token) {
  // console.log("add req body", task)
  var resp = axios.post(APP_SETTINGS.API_PATH.TASK.addProjectTask, task, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  // console.log("resp body ", resp)
  return resp;
}

export function fetchTaskboardStatuses(token) {
  return axios.get(APP_SETTINGS.API_PATH.TASK.getTaskboardStatuses, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createNewTaskboard(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.createTaskBoard, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function changeTaskStatus(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.changeTaskStatus, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function inviteEmployee(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.invite, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function removeEmployee(data, token) {
  const API_URL = `${APP_SETTINGS.API_PATH.TASK.removeEmployee}?projectId=${data.projectId}&userId=${data.userId}`;
  return axios.post(API_URL, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createQaTemplate(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TASK.addQaTemplate, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function fetchQaTemplates(data, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.TASK.fetchQaTemplates}?ProjectId=${data}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function removeQaTemplate(data, token) {
  return axios.post(
    `${APP_SETTINGS.API_PATH.TASK.removeQaTemplate}${data}`,
    { QAProtocolTemplateId: data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
